<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 slider w-100 position-relative">
        <img class="position-absolute w-100 h-100" :alt="alt" :src="image" />
        <div class="fade-in-up position-absolute w-100 h-100"></div>

        <div class="row h-100 w-100 align-items-center justify-content-center">
          <div class="content col-12 col-sm-6">
            <div class="row mt-lg-0  mt-5 ms-lg-4">
              <slot name="p-2">
              <h4 class="content-title d-block">
                نام فیلم hi from seatel from jorge j.r
              </h4>
              <p class=" d-block">
                5.5
                <span> امتیاز فیلم </span>
              </p>
              <span class="content-jear">
                <span> 2023 </span>
                <span> زمان فیلم </span>
              </span>
              <span>
                <span> بازیگران </span>
                <span>
                  j.foster , m.j laksmd , oasdn lkasnmd. masdo iansd knass
                </span>
              </span>
              <span>
                <span> ژانر </span>
                <span> zhaner vahsah shase </span>
              </span>
            </slot>
            </div>
          </div>
          <div class="col-12 col-sm-6 play-movie">
            <div class="row justify-content-center justify-content-sm-end">
              <slot name="p-1">
              <span class="font-weight-bolder"> دانلود </span>
              <i class="bi bi-play-circle icon-play"></i>
            </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mImg from "../Tags/Img";
import mA from "../Tags/A";
import { CardProps } from "./CardProps";

export default {
  name: "Cart201",
  components: { mImg, mA },
  props: {
    ...CardProps,
  },
};
</script>

<style scoped>
.slider {
  color: rgba(226, 232, 240, 0.87);
  height: 550px;
}

.slider img {
  object-fit: cover;
  z-index: -1;
  top: 0;
  right: 0;
}

.fade-in-up {
  background: linear-gradient(
    to bottom,
    transparent 20%,
    transparent 100px,
    #101014 100%
  );
  border-radius: 10px;
  z-index: 0;
  top: 0;
  right: 0;
}

.content {
  z-index: 5;
}

.play-movie {
  z-index: 5;
  cursor: pointer;
}

.play-movie span {
  font-size: 2.4rem;
}

.play-movie img {
  width: 140px;
}

.icon-play {
  font-size: 4rem
}

.content-title {
  font-size: 3rem;
}

.content-average span {
  padding-right: 10px;
}


.content-year span {
  padding-left: 10px;
}
</style>
